export default () => {
    try {
        window.localStorage.setItem("__test", "data");
        window.localStorage.removeItem("__test")
    } catch (e) {
        return false;
    }
    return true;
}